import { Instance } from '@siposdani87/sui-js';
import { app } from '../app';
import { DashboardController } from './dashboardController';

export class FeaturesIndexController extends DashboardController {
    static readonly inject = ['instances'] as const;

    organizationId!: string;

    constructor(instances: Instance) {
        super(instances);
    }

    protected override _initLayout(): void {
        this.organizationId = this.state.getParam('organizationId');

        this._initToolbarButtons();
    }

    private _initToolbarButtons(): void {
        this.helper.iconButton('.btn-organizations-show', this.dom, () => {
            this.state.goBack('organizations.show', {
                organizationId: this.organizationId,
            });
        });
    }
}

export const featuresIndexController = app.controller(
    'featuresIndexController',
    FeaturesIndexController,
);
